var path = 'app/scripts/modules/appengine/pipeline/stages/stopServerGroup/stopServerGroupStepLabel.html';
var html = "<span class=\"task-label\">\n  Stop Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/appengine/pipeline/stages/stopServerGroup/stopServerGroupStepLabel.html
// module id = 1265
// module chunks = 0